module.exports = __webpack_public_path__ + "static/44-896e1f3620cff0a93161bc44906b8b40.jpg";